import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// Multibrand-UI Components
import TextArea from '@zg-rentals/multibrand-ui/lib/TextArea';
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import Row from '@zg-rentals/multibrand-ui/lib/Row';
import Col from '@zg-rentals/multibrand-ui/lib/Col';
import Link from '@zg-rentals/multibrand-ui/lib/Link';

import SpinnerContainer from 'app/shared/components/SpinnerContainer';
import BoostAdPreviews from 'app/shared/components/BoostAdPreviews';
import DfpPreviewInFeed from 'app/shared/components/DfpPreviewInFeed';
import DfpPreviewInFeedInternal from 'app/shared/components/DfpPreviewInFeedInternal';
import DfpPreviewCustomFlag from 'app/shared/components/DfpPreviewCustomFlag';

// actions
import AnalyticsActions from 'app/shared/actions/AnalyticsActions';
import ModalActions from 'app/shared/actions/ModalActions';

// Selectors
import { AnalyticsSelectors } from 'app/shared/selectors';

// Stylesheets
import './style.scss';

const RENTAL_PARTNERS_EMAIL = 'rentalpartners@zillowgroup.com';

const propTypes = {
    boostAdPreviews: PropTypes.object.isRequired,
    insertionOrderId: PropTypes.number.isRequired,
};

class BoostAdPreviewsModal extends React.Component {
    constructor(props) {
        super(props);
        this.getBoostAdPreviews = this.getBoostAdPreviews.bind(this);
    }

    componentDidMount() {
        this.getBoostAdPreviews(this.props.insertionOrderId);
    }

    componentDidUpdate(prevProps) {
        const { boostAdPreviews, dispatch } = this.props;
        const propertyName = boostAdPreviews.propertyDetails.name;
        if (propertyName !== prevProps.boostAdPreviews.propertyDetails.name) {
            const header = propertyName ? `Ad for ${propertyName}` : null;
            dispatch(ModalActions.updateModal({ header }));
        }
    }

    getBoostAdPreviews(insertionOrderId) {
        if (!insertionOrderId) {
            return;
        }

        this.props.dispatch(AnalyticsActions.getBoostAdPreviews({ insertionOrderId }));
    }

    renderLoadingComplete() {
        const { boostAdPreviews } = this.props;
        const {
            error,
            previews,
            dfpPreview,
            isActive,
        } = boostAdPreviews;
        const isInFeed = dfpPreview && dfpPreview.creativeTemplateType === 'IN_FEED';
        const isInFeedInternal = dfpPreview && dfpPreview.creativeTemplateType === 'IN_FEED_INTERNAL';
        const isCustomFlag = dfpPreview && dfpPreview.creativeTemplateType === 'CUSTOM_FLAG';

        if (error) {
            return <Text className="error">Something went wrong. Please, try again later.</Text>;
        }
        if (previews.length === 0 && !dfpPreview.creativeTemplateType) {
            return <Text className="error">No ad available.</Text>;
        }
        return (
            <div>
                <Text
                    className="BoostAdPreviewsModal-dfp-title"
                    type="h4"
                    uppercase={true}
                    emphasize={true}
                >
                    ZILLOW
                </Text>
                <div className="BoostAdPreviewsModal-inactive-wrapper">
                    {isInFeed && <DfpPreviewInFeed templateValues={dfpPreview.templateValues} />}
                    {isInFeedInternal && <DfpPreviewInFeedInternal templateValues={dfpPreview.templateValues} />}
                    {isCustomFlag && <DfpPreviewCustomFlag templateValues={dfpPreview.templateValues} />}
                    <div className={isActive ? '' : 'BoostAdPreviewsModal-inactive-overlay'}>
                        {!isActive && (
                            <Text
                                type="h4"
                                className="BoostAdPreviewsModal-inactive-text"
                                emphasize={true}
                            >
                                Ad no longer available
                            </Text>
                        )}
                    </div>
                </div>
                <BoostAdPreviews previews={previews} />
                <Row>
                    <Col>
                        <TextArea
                            autosize={true}
                            label="Landing Page URL"
                            value={dfpPreview.templateValues.destinationUrl}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Text>
                            For ad text or URL changes please contact&nbsp;
                            <Link href={`mailto:${RENTAL_PARTNERS_EMAIL}`} escape={true}>
                                {RENTAL_PARTNERS_EMAIL}
                            </Link>
                        </Text>
                    </Col>
                </Row>
            </div>
        );
    }

    render() {
        return (
            <div>
                {this.props.boostAdPreviews.isLoading ? <SpinnerContainer /> : this.renderLoadingComplete()}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    boostAdPreviews: AnalyticsSelectors.makeBoostAdPreviews(state),
});

BoostAdPreviewsModal.propTypes = propTypes;

export { BoostAdPreviewsModal };
export default connect(mapStateToProps)(BoostAdPreviewsModal);
